import axios from "axios";
import routes from "app/routes";

export const Actions = {
  load: (dispatch) => {
    axios
      .get(routes.api.policy_plans.index, {
        params: {
          "q[s]": "renewal_date ASC",
        },
      })
      .then((resp) => {
        dispatch({ type: "load", plans: resp.data.data });
      });
  },
};
